import * as React from "react";
import { cn } from "@/lib/utils";

const variants = {
  default: "bg-primary/10 text-primary hover:bg-primary/20",
  outline: "border border-current",
  destructive: "bg-red-100 text-red-700 hover:bg-red-200",
} as const;

const Badge = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    variant?: keyof typeof variants;
  }
>(({ className, variant = "default", ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors",
      variants[variant],
      className
    )}
    {...props}
  />
));

Badge.displayName = "Badge";

export { Badge, variants };